import { AnyAction, Reducer } from 'redux';

export const STORE_DESIGNPREFERENCES_DATA = 'store/designprefernces-codes-dropdown';
export const STORE_CUST_DESIGNPREFERENCE_DATA = 'customer/designpreference-data';
export const STORE_CUST_DESIGNPREFERENCE_DATA_INITIAL = 'initial-value-from-api-customer/designpreference-data';
export const STORE_MATERIALFILES_DATA = 'initial-value-from-api-customer/materialfiles-data';

export interface MaterialFilesData {
    rowno: string;
    custcode: string;
    custname: string;
    uploadedon: string;
    custfile: string;
    action: string;
}

export interface MaterialFilesState {
    materialFilesData: MaterialFilesData[];

}

const initialState: MaterialFilesState = {
    materialFilesData: [],

};

const reducer: Reducer<MaterialFilesState> = (state: MaterialFilesState = initialState, action: AnyAction): MaterialFilesState => {
    switch (action.type) {

        case STORE_MATERIALFILES_DATA:
            return {
                ...state,
                materialFilesData: action.materialFilesData
            };

        default:
            return state;
    }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/materialFiles.tsx